let baseURL = `${process.env.REACT_APP_PLATFORM_API_BASE_URL}`;

const GENERIC_UPLOAD_ERROR =
  "Something went wrong while uploading your files. Please try again.";

const createRequestError = (message, status, code) => {
  const error = new Error(message);
  error.status = status;
  error.code = code;
  return error;
};

export const getInvite = async (inviteId) => {
  const url = `${baseURL}/${inviteId}`;
  const res = await fetch(url);
  const data = await res.json();
  return data;
};

export const clickInvite = async (inviteId) => {
  const url = `${baseURL}/${inviteId}/click`;
  const res = await fetch(url);
  if (!res.ok) {
    throw createRequestError("Invite not found", res.status, "INVITE_EXPIRED");
  }
};

export const createFileUploadURL = async (inviteId, fileName) => {
  const url = `${baseURL}/api/invite/${inviteId}/file?filename=${encodeURIComponent(
    fileName
  )}`;
  const res = await fetch(url, {
    method: "POST",
  });

  if (!res.ok) {
    throw createRequestError(
      GENERIC_UPLOAD_ERROR,
      res.status,
      "UPLOAD_URL_FAILED"
    );
  }

  const data = await res.json();
  return data;
};

export const uploadFile = async (uploadURL, imgFile) => {
  const res = await fetch(uploadURL, {
    method: "PUT",
    body: imgFile,
    headers: imgFile?.type
      ? {
          "Content-Type": imgFile.type,
        }
      : undefined,
  });

  if (!res.ok) {
    throw createRequestError(
      GENERIC_UPLOAD_ERROR,
      res.status,
      "UPLOAD_FAILED"
    );
  }
};
